<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item label="名称" prop="name">
            <el-input
              size="small"
              v-model="filter.name"
              @keyup.enter.native="requestSearch"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestSearch"
            >筛选</el-button
          >
          <el-button size="small" @click="requestSearch('reset')"
            >重置</el-button
          >
        </div>
      </div>
    </div> -->

    <div class="panel mt-20">
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="服务"
          name="1"
          v-if="auth.belongsToDepartment(1)"
        ></el-tab-pane>
        <el-tab-pane
          label="工业"
          name="2"
          v-if="auth.belongsToDepartment(2)"
        ></el-tab-pane>
        <el-tab-pane
          label="科学"
          name="3"
          v-if="auth.belongsToDepartment(3)"
        ></el-tab-pane>
      </el-tabs>

      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-permission="Auth.commodityCategoryCreate"
          @click="handleNew"
          >新增一级分类</el-button
        >
        <el-form
          :model="filter"
          inline
          ref="filterForm"
          label-position="left"
          label-width="0"
          @submit.native.prevent
        >
          <el-form-item class="mb-0">
            <el-select
              v-model="filter.mp_visible"
              size="small"
              placeholder="小程序展示配置"
            >
              <el-option label="不展示" key="1" :value="1"></el-option>
              <el-option label="展示" key="2" :value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" prop="name" class="mb-0">
            <el-input
              size="small"
              v-model="filter.name"
              @keyup.enter.native="requestSearch"
              placeholder="名称"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item class="mb-0">
            <el-button type="primary" size="small" @click="requestSearch"
              >筛选</el-button
            >
            <el-button size="small" @click="requestSearch('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table v-if="!isMobile()" :data="list" stripe style="width: 100%">
        <el-table-column align="left" label="分类封面">
          <template slot-scope="scope">
            <div class="pointer" @click.prevent="showDetail(scope.row)">
              <auth-img
                tag="el-image"
                style="width: 60px; height: 60px"
                :src="scope.row.cover"
                fit="cover"
              ></auth-img>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" label="分类名称" prop="whole_name">
          <template slot-scope="scope">
            <div
              class="pointer text-primary"
              @click.prevent="showDetail(scope.row)"
            >
              {{ scope.row.whole_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="商品数量"
          prop="commodity_count"
        ></el-table-column>
        <el-table-column align="center" label="小程序是否展示">
          <template slot-scope="scope">
            {{ scope.row.mp_visible == 1 ? '不展示' : '展示' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <status-tag
              :type="scope.row.status == 1 ? 'success' : 'gray'"
              :name="scope.row.status == 1 ? '已启用' : '已禁用'"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              class="mr-10"
              plain
              @click="handleNew(scope.row, scope.$index)"
              >添加子分类</el-button
            >
            <el-popconfirm
              v-permission="Auth.commodityCategoryStatusManage"
              :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button
                slot="reference"
                :type="scope.row.status == 1 ? 'danger' : 'primary'"
                plain
                size="mini"
                >{{ scope.row.status == 1 ? '禁用' : '启用' }}</el-button
              >
            </el-popconfirm>
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.commodityCategoryUpdate"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="handlePageChange"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <item-former
      :model="model"
      :show.sync="itemFormerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></item-former>

    <ModelDetail :model="showItem" :show.sync="detailDialog"></ModelDetail>
  </div>
</template>

<script>
import {
  commodityCategoryList,
  updateCommodityCategoryStatus,
} from '@/service/getData'
import { isMobile } from '../../../util'
import ItemFormer from './former'
import { clone } from '@/util'
import auth from '@/util/auth'
import store from '@/store/store'
import ModelDetail from './detail.vue'

export default {
  components: {
    ItemFormer,
    ModelDetail,
  },
  data() {
    return {
      auth,
      activeName: (store.getters.userInfo.departments[0] || 0).toString(),
      model: { cover: '', name: '', mp_visible: 1, content: '' },
      itemFormerVisible: false,
      editIndex: 0,
      isMobile,
      list: [],
      total: 0,
      filter: {
        department_id: store.getters.userInfo.departments[0] || 0,
        sum_commdity_count: true,
        size: 20,
        page: 1,
        name: '',
        mp_visible: '',
      },
      showItem: {},
      detailDialog: false,
    }
  },
  watch: {
    'filter.page': function () {
      this.getData()
    },
    activeName: function (n, o) {
      this.filter.department_id = n
      this.requestSearch('reset')
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let params = clone(this.filter)
      params.page -= 1

      let res = await commodityCategoryList(params)
      this.list = res.data.list
      this.total = res.data.total
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.name = ''
        this.filter.mp_visible = ''
      }
      this.getData()
    },
    handlePageChange(e) {
      this.filter.page = e
      this.loading = true
      this.getData()
    },
    createdCallback(data) {
      this.list.splice(this.editIndex, 0, data)
    },
    updatedCallback(data) {
      data.commodity_count = this.list[this.editIndex].commodity_count
      this.$set(this.list, this.editIndex, data)
    },
    handleNew(cate, index) {
      this.editIndex = 0
      let father_id = 0
      let level = 1
      let father_name = ''
      let mp_visible = 1
      if (cate) {
        this.editIndex = index + 1
        father_id = cate.id
        father_name = cate.name
        level = cate.level + 1
        mp_visible = cate.mp_visible || 1
      }
      this.model = {
        name: '',
        cover: '',
        father_id: father_id,
        level: level,
        father_name: father_name,
        department_id: parseInt(this.filter.department_id),
        mp_visible: mp_visible,
        content: '',
      }
      this.itemFormerVisible = true
    },
    handleEdit(index, item) {
      this.itemFormerVisible = true
      this.$nextTick(() => {
        this.model = clone(item)
        this.model.father_name = this.model.father.name
        this.editIndex = index
      })
    },
    async handleSwitchStatus(index, id) {
      let res = await updateCommodityCategoryStatus(id)
      if (res.code == 0) {
        this.list[index].status = res.data.status
      }
    },
    showDetail(item) {
      this.showItem = item
      this.detailDialog = true
    },
  },
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>